export default __webpack_public_path__ + "6a9e45250c257594105ff6cb5f9e6b7b.png";